export let BASE_URL = process.env.REACT_APP_BASE_URL
export let REACT_APP_PORT = process.env.REACT_APP_PORT
export let BASE_API_URL = process.env.REACT_APP_BASE_API_URL
export let MINI_API_URL = process.env.REACT_APP_MINI_API_URL
export let ENV_NAME = process.env.REACT_APP_ENV_NAME
export const location = window && window.location
export let SPACES_BUCKET = process.env.REACT_APP_SPACES_BUCKET
export let SPACES_ENDPOINT = process.env.REACT_APP_SPACES_ENDPOINT
export let SPACES_ACCESS_KEY = process.env.REACT_APP_SPACES_ACCESS_KEY
export let SPACES_SECRET_KEY = process.env.REACT_APP_SPACES_SECRET_KEY

export const hostname = `${location.protocol}//${location.hostname}`
